/* Strata measurement: clicks indicate intent, not completed leads or sales. */
(function () {
  'use strict';
  if (window.strataMeasurementLoaded) return;
  window.strataMeasurementLoaded = true;
  var id = 'G-WYSYNQBTHD';
  var pageType = (document.currentScript && document.currentScript.dataset.pageType) || 'other';
  if (['index','product','collection','page','article','blog','cart'].indexOf(pageType) < 0) pageType = 'other';
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', {analytics_storage:'denied', ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied'});
  var lastPermission = null;
  var started = false;
  var scriptLoaded = false;
  // Load gtag.js only once the page has painted; queued dataLayer calls are replayed on load.
  function loadScript() {
    if (scriptLoaded) return;
    scriptLoaded = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
    document.head.appendChild(script);
  }
  function scheduleLoad() {
    if (scriptLoaded) return;
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () { loadScript(); }, {timeout:2500});
      return;
    }
    if (document.readyState === 'complete') loadScript();
    else window.addEventListener('load', function () { loadScript(); }, {once:true});
  }
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function safeReferrer() {
    try { return new URL(document.referrer).origin + '/'; } catch (_) { return ''; }
  }
  function update() {
    var permit = allowed();
    window['ga-disable-' + id] = !permit;
    if (permit !== lastPermission) {
      window.gtag('consent', 'update', {analytics_storage:permit ? 'granted' : 'denied', ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied'});
      lastPermission = permit;
    }
    if (!permit) return;
    if (started) return;
    started = true;
    window.gtag('js', new Date());
    var config = {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      page_location: window.location.origin + window.location.pathname,
      page_referrer: safeReferrer(),
      page_title: 'Strata Peptides | ' + pageType
    };
    var params = new URL(window.location.href).searchParams;
    var source = (params.get('utm_source') || '').toLowerCase();
    var medium = (params.get('utm_medium') || '').toLowerCase();
    var social = ['instagram','facebook','tiktok','youtube','x','twitter','linkedin'];
    if (['chatgpt.com','perplexity.ai','google','bing','whatsapp','newsletter'].concat(social).indexOf(source) >= 0) {
      config.campaign_source = source;
      config.campaign_medium = ['organic','referral','social','paid_social','cpc','ppc','email','display'].indexOf(medium) >= 0 ? medium : social.indexOf(source) >= 0 ? 'social' : source === 'newsletter' ? 'email' : 'referral';
    }
    // Campaign/content/search-term values stay excluded: they may contain personal data.
    window.gtag('config', id, config);
    window.gtag('event', 'page_view', {send_to:id, page_type:pageType});
    scheduleLoad();
  }
  var lastClick = 0;
  document.addEventListener('click', function (event) {
    if (!allowed()) return;
    var anchor = event.target && event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;
    var url;
    try { url = new URL(anchor.href, window.location.origin); } catch (_) { return; }
    if (url.protocol !== 'https:' || url.hostname !== 'wa.me' || !/^\/201041446969\/?$/.test(url.pathname)) return;
    if (Date.now() - lastClick < 500) return;
    lastClick = Date.now();
    update();
    // A leaving click must not wait for the idle loader.
    loadScript();
    var placement = anchor.closest('[data-strata-whatsapp]') ? 'floating' : anchor.closest('footer') ? 'footer' : 'content';
    var eventData = {send_to:id, page_type:pageType, link_placement:placement};
    // Keep the page alive briefly for a real same-tab click, but never trap navigation.
    if (event.isTrusted && event.cancelable && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!anchor.target || anchor.target === '_self')) {
      event.preventDefault();
      var navigated = false;
      var continueToWhatsApp = function () {
        if (navigated) return;
        navigated = true;
        window.location.assign(anchor.href);
      };
      eventData.event_callback = continueToWhatsApp;
      eventData.event_timeout = 700;
      setTimeout(continueToWhatsApp, 750);
    }
    // Let gtag choose the supported transport instead of forcing sendBeacon.
    window.gtag('event', 'whatsapp_click', eventData);
  }, true);
  document.addEventListener('visitorConsentCollected', update);
  if (window.Shopify && window.Shopify.customerPrivacy) update();
  else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function(error) { if (!error) update(); });
  }
})();
